


// // import React, { useState, useEffect } from "react";
// // import {
// //     Box,
// //     IconButton,
// //     List,
// //     ListItem,
// //     ListItemButton,
// //     ListItemText,
// //     Drawer,
// //     useMediaQuery,
// //     useTheme,
// //     Collapse,
// // } from "@mui/material";
// // import { useNavigate, useLocation } from "react-router-dom";
// // import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// // import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// // import {
// //     Home as HomeIcon,
// //     RestaurantMenu as RestaurantMenuIcon,
// //     Apartment as ApartmentIcon,
// //     Settings as SettingsIcon,
// //     Dashboard as DashboardIcon,
// //     DinnerDining as DinnerDiningIcon,
// //     Payment as PaymentIcon,
// //     Assessment as AssessmentIcon,
// //     Dashboard
// // } from "@mui/icons-material";
// // import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
// // import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// // import ExpandLess from "@mui/icons-material/ExpandLess";
// // import ExpandMore from "@mui/icons-material/ExpandMore";
// // import {
// //     FaUtensils,
// //     FaConciergeBell,
// //     FaShoppingBasket,
// //     FaBuilding
// // } from "react-icons/fa";
// // import { Table } from "lucide-react";

// // // All possible menu items - these will only open dropdowns, not navigate
// // const allMenuItems = [
// //     // { text: "Subscription", icon: <HomeIcon />, vertical: "SUBSCRIPTION" },
// //     { text: "Food & Beverages", route: "/foodladingpage", vertical: "FOOD_AND_BEVERAGES" },
// //     { text: "Catering & Services", icon: <RestaurantMenuIcon />, vertical: "FOOD_AND_BEVERAGES" },
// //     // { text: "Logistics & Supply", icon: <LocalShippingIcon />, vertical: "LOGISTICS_SUPPLY" },
// //     // { text: "Fresh & Grocery", icon: <ShoppingBasketIcon />, vertical: "FRESH_GROCERIES" }
// // ];

// // const subscriptionEnumToMenuItemMap = {
// //     Food_Beverages: {
// //         text: "Food & Beverages",
// //         icon: FaUtensils,
// //         route: "/mainladdingpage?vertical=food"
// //     },
// //     Catering_Services: {
// //         text: "Catering & Services",
// //         icon: FaConciergeBell,
// //         route: "/mainladdingpage?vertical=catering"
// //     },
// //     Fresh_Grocery: {
// //         text: "Fresh & Grocery",
// //         icon: FaShoppingBasket,
// //         route: "/mainladdingpage?vertical=grocery"
// //     },
// //     Logistics_Supply: {
// //         text: "Logistics & Supply",
// //         icon: LocalShippingIcon,
// //         route: "/mainladdingpage?vertical=logistics"
// //     },
// //     Banquet_Hall: {
// //         text: "Banquet Hall",
// //         icon: FaBuilding,
// //         route: "/mainladdingpage?vertical=banquet"
// //     },
// // };

// // // Your actual dropdown content mapping with safe icon handling
// // const enumToMenuItemMap = {
// //     Dashboard: {
// //         text: "Dashboard", icon: HomeIcon,
// //         route: "/fooddashboard"
// //     },
// //     // Home: { text: "Home", icon: HomeIcon, route: "/foodladingpage" },
// //     Company: { text: "Business Profile", icon: ApartmentIcon, route: "/foodbeveragescompany" },
// //     Team_Managment: {text: "Team", route: "/teammanagment"},
// //     Settings_Controls: {
// //         text: "Settings & Control",
// //         icon: SettingsIcon,
// //         route: "/foodsettings"
// //     },
// //     Menu_Management: {
// //         text: "Menu",
// //         icon: RestaurantMenuIcon,
// //         route: "/foodandbeveragesMenu"
// //     },
// //     Order_Management: {
// //         text: "Order",
// //         icon: DashboardIcon,
// //         route: "/foodordermanagment"
// //     },
// //     Chef_Management: {
// //         text: "Chef",
// //         icon: RestaurantMenuIcon,
// //         route: "/foodchefmanagment"
// //     },
// //     Delivery_Management: {
// //         text: "Delivery",
// //         icon: DinnerDiningIcon,
// //         route: "/foodwaitermanagment"
// //     },
// //     Account_History: {
// //         text: "Account & History",
// //         icon: PaymentIcon,
// //         route: "/foodAccuontdata"
// //     },
// //     Promotions_Discounts: {
// //         text: "Promotions",
// //         icon: PaymentIcon,
// //         route: "/foodandbeveragespromotions"
// //     },
// //     Table_Management: {
// //         text: "Table",
// //         icon: AssessmentIcon,
// //         route: "/foodtablemanagment"
// //     },
// //     // Inventory_Management: {
// //     //     text: "Inventory",
// //     //     icon: PaymentIcon,
// //     //     route: "/foodandbeveragesInvetory"
// //     // },
// //     Report_Analysis: {
// //         text: "Report & Analysis",
// //         icon: AssessmentIcon,
// //         route: "/foodandreporanalysis"
// //     },
// //     // Support_System: {
// //     //     text: "Support System",
// //     //     route: "/foodsupportsystem"
// //     // },
// //     Legal_Compliance: {
// //         text: "Leagl & Complaince",
// //         route: "/foodsupportsystem"
// //     }
// // };

// // const cateringEnumToMenuItemMap = {
// //     Home: { text: "Home", icon: HomeIcon, route: "/cateringlading" },
// //     Company: { text: "Profile", icon: ApartmentIcon, route: "/cateringsprofilepage" },
// //     Settings_Controls: {
// //         text: "Settings & Control",
// //         icon: SettingsIcon,
// //         route: "/cateringssettingpage"
// //     },
// //     Menu_Management: {
// //         text: "Menu",
// //         icon: RestaurantMenuIcon,
// //         route: "/cateringsmenuaddingpage"
// //     },
// //     Order_Management: {
// //         text: "Leads Orders",
// //         icon: DashboardIcon,
// //         route: "/cateringsorderspage"
// //     },
// //     Table_Management: {
// //         text: "Package Orders",
// //         icon: DashboardIcon,
// //         route: "/cateringpackageorders"
// //     },
// //     Account_History: {
// //         text: "Account & History",
// //         icon: PaymentIcon,
// //         route: "/caterigsaccount"
// //     },
// //     Promotions_Discounts: {
// //         text: "Promotions",
// //         icon: PaymentIcon,
// //         route: "/cateringspromotionspage"
// //     },
// //     Report_Analysis: {
// //         text: "Report & Analysis",
// //         icon: AssessmentIcon,
// //         route: "/cateringsreportanalysis"
// //     },
// // }

// // const groceryEnumMenuToMap = {
// //     Home: { text: "Home", icon: HomeIcon, route: "/groceryladingpage" },
// //     Company: { text: "Profile", icon: ApartmentIcon, route: "/groceryprofiledata" },
// //     Settings_Controls: {
// //         text: "Settings & Control",
// //         icon: SettingsIcon,
// //         route: "/grocerysettingsdata"
// //     },
// //     Menu_Management: {
// //         text: "Menu",
// //         icon: RestaurantMenuIcon,
// //         route: "/groceryandbeveragesMenu"
// //     },
// //     Order_Management: {
// //         text: "Order",
// //         icon: DashboardIcon,
// //         route: "/groceryorders"
// //     },
// //     Account_History: {
// //         text: "Account & History",
// //         icon: PaymentIcon,
// //         route: "/groceryaccuontdata"
// //     },
// //     Promotions_Discounts: {
// //         text: "Promotions",
// //         icon: PaymentIcon,
// //         route: "/groceryandbeveragespromotions"
// //     },
// //     Inventory_Management: { text: "Inventory", icon: PaymentIcon, route: "/groceryandbeveragesInvetory" },
// //     Report_Analysis: {
// //         text: "Report & Analysis",
// //         icon: AssessmentIcon,
// //         route: "/groceryandreporanalysis"
// //     },
// // }

// // const LandingSideBar2 = () => {
// //     const [open, setOpen] = useState(false);
// //     const [menuItems, setMenuItems] = useState([]);
// //     const [dropdownOpen, setDropdownOpen] = useState(false);
// //     const [selectedItem, setSelectedItem] = useState(null);
// //     const [allowedModules, setAllowedModules] = useState([]);
// //     const [allowedBusinessVerticals, setAllowedBusinessVerticals] = useState([]);
// //     const [filteredMenuItems, setFilteredMenuItems] = useState([]); // NEW: For permission-based filtering
// //     const navigate = useNavigate();
// //     const location = useLocation();
// //     const theme = useTheme();

// //     // Media queries
// //     const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
// //     const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));
// //     const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
// //     const isBelow500 = useMediaQuery("(max-width:500px)");
// //     const isBelow1315 = useMediaQuery("(max-width:1315px)");
// //     const isBetween1315And1399 = useMediaQuery("(min-width:1315px) and (max-width:1399px)");
// //     const isAbove1400 = useMediaQuery("(min-width:1450px)");

// //     // Your custom window width detection
// //     const isMobilee = window.innerWidth < 600;        // < 600px
// //     const isTablett = window.innerWidth >= 600 && window.innerWidth < 999; // 600px - 999px
// //     const isDesktopp = window.innerWidth >= 999;          // > 999px

// //     const showHamburger = isMobilee || isTablett; // true for mobile AND tablet

// //     let drawerWidth = 189; // default

// //     if (isBelow500) {
// //         drawerWidth = 250;
// //     } else if (isBelow1315) {
// //         drawerWidth = 176;
// //     } else if (isBetween1315And1399) {
// //         drawerWidth = 190;
// //     } else if (isAbove1400) {
// //         drawerWidth = 208;
// //     }

// //     const getIconSize = () => (isMobile ? "small" : "medium");
// //     const getTextSize = () => (isMobile ? "12px" : isTablet ? "0.8rem" : "1rem");

// //     // Set initial open state based on your custom window width detection
// //     useEffect(() => {
// //         if (showHamburger) {
// //             setOpen(false); // Closed by default on mobile/tablet
// //         } else {
// //             setOpen(true);  // Always open on desktop
// //         }
// //     }, [showHamburger]);

// //     // Permission-based module filtering - FROM REFERENCE FILE
// //     useEffect(() => {
// //         const employeeId = localStorage.getItem("employeeId");

// //         // Get login data
// //         const loginData = JSON.parse(localStorage.getItem("loginResponse") || "{}");
// //         const modulesFromResponse = loginData?.modules || [];
// //         const planTypes = loginData?.planTypes || [];
// //         const businessVerticalsFromResponse = loginData?.businessVerticals || [];

// //         let filteredModules = [];
// //         let filteredBusinessVerticals = [];

// //         if (employeeId && employeeId !== "0") {
// //             // Employee → show only modules from login response
// //             filteredModules = modulesFromResponse.map(m => m.trim().replace(/\s+/g, "_"));
// //             filteredBusinessVerticals = businessVerticalsFromResponse;
// //         } else {
// //             // Parent vendor → show modules depending on plan type
// //             if (planTypes.includes("BASIC")) {
// //                 // BASIC has highest priority
// //                 filteredModules = [
// //                     "Dashboard",
// //                     "Company",
// //                     "Team_Managment",
// //                     "Home",
// //                     "Settings_Controls",
// //                     "Order_Management",
// //                     "Menu_Management",
// //                     "Account_History",
// //                     "Report_Analysis",
// //                     "Promotions_Discounts"
// //                 ];
// //                 filteredBusinessVerticals = ["FOOD_AND_BEVERAGES", "CATERINGS_SERVICES"];
// //             } else if (planTypes.includes("PREMIUM")) {
// //                 filteredModules = Object.keys(enumToMenuItemMap); // all modules
// //                 filteredBusinessVerticals = businessVerticalsFromResponse;
// //             } else if (planTypes.includes("STANDARD")) {
// //                 filteredModules = modulesFromResponse.length > 0
// //                     ? modulesFromResponse.map(m => m.trim().replace(/\s+/g, "_"))
// //                     : ["Home", "Order_Management"];
// //                 filteredBusinessVerticals = businessVerticalsFromResponse;
// //             } else {
// //                 filteredModules = ["Home", "Order_Management"];
// //                 filteredBusinessVerticals = businessVerticalsFromResponse;
// //             }
// //         }

// //         // console.log("✅ Allowed modules:", filteredModules);
// //         // console.log("✅ Allowed businessVerticals:", filteredBusinessVerticals);

// //         setAllowedModules(filteredModules);
// //         setAllowedBusinessVerticals(filteredBusinessVerticals);

// //         // NEW: Apply permission filtering to menu items - FROM REFERENCE FILE
// //         const permissionFilteredItems = Object.keys(enumToMenuItemMap)
// //             .filter((key) => filteredModules.includes(key))
// //             .map((key) => enumToMenuItemMap[key]);

// //         setFilteredMenuItems(permissionFilteredItems);
// //         //console.log("✅ Permission filtered menu items:", permissionFilteredItems);

// //     }, []);

// //     // Filter menu items based on business verticals
// //     useEffect(() => {
// //         const loginData = JSON.parse(localStorage.getItem("loginResponse"));
// //         const businessVerticals = loginData?.businessVerticals || [];

// //         const filteredMenu = allMenuItems.filter(
// //             (item) =>
// //                 item.text === "Subscription" || businessVerticals.includes(item.vertical)
// //         );

// //         setMenuItems(filteredMenu);
// //     }, []);

// //     const handleMenuItemClick = (item) => {
// //         // Toggle dropdown - only open/close dropdown, no navigation
// //         if (selectedItem?.text === item.text) {
// //             setDropdownOpen(!dropdownOpen);
// //         } else {
// //             setSelectedItem(item);
// //             setDropdownOpen(true);
// //         }
// //     };

// //     const handleDropdownItemClick = (route) => {
// //         // This will handle navigation for dropdown items
// //         navigate(route);
// //         if (isMobile) setOpen(false);
// //         // setDropdownOpen(false); // Close dropdown after navigation
// //     };

// //     // Safe icon renderer function
// //     const renderIcon = (IconComponent, size) => {
// //         if (!IconComponent || typeof IconComponent === 'undefined') {
// //             return <DashboardIcon fontSize={size} />; // Fallback icon
// //         }
// //         return <IconComponent fontSize={size} />;
// //     };

// //     // Filter dropdown content based on allowed modules - UPDATED with permission filtering
// //     const getDropdownContent = (item) => {
// //         let dropdownItems = [];

// //         switch (item.text) {
// //             case "Food & Beverages":
// //                 // NEW: Use permission-filtered items instead of all items
// //                 dropdownItems = filteredMenuItems.length > 0 ? filteredMenuItems : Object.values(enumToMenuItemMap);
// //                 break;
// //             case "Subscription":
// //                 dropdownItems = Object.values(subscriptionEnumToMenuItemMap);
// //                 break;
// //             case "Catering & Services":
// //                 dropdownItems = Object.values(cateringEnumToMenuItemMap);
// //                 break;
// //             case "Logistics & Supply":
// //                 dropdownItems = [
// //                     { text: "Shipping", icon: LocalShippingIcon, route: "/shipping" },
// //                     { text: "Warehouse", icon: LocalShippingIcon, route: "/warehouse" },
// //                 ];
// //                 break;
// //             case "Fresh & Grocery":
// //                 dropdownItems = Object.values(groceryEnumMenuToMap);
// //                 break;
// //             default:
// //                 dropdownItems = [];
// //         }

// //         // Additional filtering based on allowed modules for cross-vertical consistency
// //         return dropdownItems.filter(dropdownItem => {
// //             // Find the module key that matches this dropdown item
// //             const moduleKey = Object.keys(enumToMenuItemMap).find(key =>
// //                 enumToMenuItemMap[key].text === dropdownItem.text
// //             );

// //             // If we found a module key, check if it's allowed
// //             // If no module key found (different vertical), allow it
// //             return !moduleKey || allowedModules.includes(moduleKey);
// //         });
// //     };

// //     return (
// //         <>
// //             {/* Open Panel Button - Only show when panel is closed */}
// //             {!open && (
// //                 <Box
// //                     sx={{
// //                         position: "fixed",
// //                         top: isMobile ? "12%" : "150px",
// //                         left: isMobile ? "10px" : "10px",
// //                         zIndex: 1500,
// //                         display: window.innerWidth <= 900 ? "block" : "none",
// //                     }}
// //                 >
// //                     <IconButton
// //                         onClick={() => setOpen(true)}
// //                         sx={{
// //                             color: "#b15cd6",
// //                             backgroundColor: "white",
// //                             boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
// //                             '&:hover': {
// //                                 backgroundColor: "#f5f5f5",
// //                             },
// //                             height:"25px",
// //                             width:"25px",
// //                         }}
// //                     >
// //                         <ArrowForwardIosIcon />
// //                     </IconButton>
// //                 </Box>
// //             )}

// //             <Drawer
// //                 anchor="left"
// //                 variant={showHamburger ? "temporary" : "persistent"}
// //                 open={open}
// //                 onClose={showHamburger ? () => setOpen(false) : undefined}
// //                 PaperProps={{
// //                     sx: {
// //                         marginTop: isMobile ? "52px" : "118px",
// //                         height: isMobile ? "calc(100vh - 50px)" : "calc(100vh - 50px)",
// //                         width: drawerWidth,
// //                         scrollbarWidth: "none",
// //                         backgroundColor: "#fff",
// //                         border: "3px solid white",
// //                         overflow: 'hidden', // Changed from auto to hidden
// //                         '&::-webkit-scrollbar': {
// //                             display: 'none'
// //                         },
// //                         scrollbarWidth: 'none',
// //                         '-ms-overflow-style': 'none',
// //                         zIndex: 1001,
// //                         left:"10px",
// //                     },
// //                 }}
// //                 ModalProps={{ keepMounted: true }}
// //             >
// //                 <Box sx={{
// //                     flexShrink: 0, // Prevents this from shrinking
// //                     background: '#fff',
// //                     zIndex: 10,
// //                     position: 'sticky',
// //                     top: 0,
// //                 }}>
// //                     <List sx={{ paddingTop: "8px", marginBottom: "0px",paddingBottom:"0px" }}>
// //                         {menuItems.length === 0 ? (
// //                             <Box sx={{ color: "gray", padding: "1rem", textAlign: "center", fontSize: getTextSize() }}>
// //                                 No menu items found
// //                             </Box>
// //                         ) : (
// //                             menuItems.map((item, index) => {
// //                                 const dropdownContent = getDropdownContent(item);
// //                                 const isSelected = selectedItem?.text === item.text;

// //                                 return (
// //                                     <React.Fragment key={index} >
// //                                         <ListItem disablePadding sx={{ marginTop: "0px",marginBottom:"0px" }}>
// //                                             <ListItemButton
// //                                                 sx={{
// //                                                     background: isSelected && dropdownOpen ? "#A055B0" : "#B276C3",
// //                                                     borderRadius: "20px",
// //                                                     marginBottom: "10px",
// //                                                     color: "#fff",
// //                                                     "&:hover": { background: "#A055B0" },
// //                                                     padding: "10px 16px",
// //                                                     position: "relative",
// //                                                 }}
// //                                                 onClick={() => handleMenuItemClick(item)}
// //                                             >
// //                                                 {/* Close Panel Button */}
// //                                                 {open && (
// //                                                     <IconButton
// //                                                         size="small"
// //                                                         onClick={(e) => {
// //                                                             e.stopPropagation();
// //                                                             setOpen(false);
// //                                                         }}
// //                                                         sx={{
// //                                                             color: "#fff",
// //                                                             position: "absolute",
// //                                                             left: "5px",
// //                                                             top: "45%",
// //                                                             transform: "translateY(-50%)",
// //                                                             backgroundColor: "rgba(255,255,255,0)",
// //                                                             '&:hover': {
// //                                                                 backgroundColor: "rgba(255,255,255,0)",
// //                                                             },
// //                                                             marginRight: "5px",
// //                                                             display: window.innerWidth <= 990 ? "block" : "none",
// //                                                         }}
// //                                                     >
// //                                                         <ArrowBackIosIcon fontSize="small" />
// //                                                     </IconButton>
// //                                                 )}

// //                                                 <ListItemText
// //                                                     primary={item.text}
// //                                                     primaryTypographyProps={{
// //                                                         style: {
// //                                                             fontSize: getTextSize(),
// //                                                             fontWeight: "bold",
// //                                                             marginLeft: window.innerWidth <= 990 ? "10px" : "0px",


// //                                                         },
// //                                                     }}
// //                                                 />

// //                                                 {dropdownContent.length > 0 && (
// //                                                     isSelected && dropdownOpen ? <ExpandLess /> : <ExpandMore />
// //                                                 )}
// //                                             </ListItemButton>
// //                                         </ListItem>
// //                                     </React.Fragment>
// //                                 );
// //                             })
// //                         )}
// //                     </List>
// //                 </Box>

// //                 {/* Scrollable Area for Sub-buttons */}
// //                 <Box sx={{
// //                     flex: 1, // Takes remaining space
// //                     overflowY: 'auto',
// //                     paddingBottom: '20px',
// //                     '&::-webkit-scrollbar': {
// //                         display: 'none'
// //                     },
// //                     scrollbarWidth: 'none',
// //                     '-ms-overflow-style': 'none'
// //                 }}>
// //                     {menuItems.map((item, index) => {
// //                         const dropdownContent = getDropdownContent(item);
// //                         const isSelected = selectedItem?.text === item.text;

// //                         return (
// //                             dropdownContent.length > 0 && isSelected && dropdownOpen && (
// //                                 <Box key={`dropdown-${index}`} sx={{ marginBottom: "10px" }}>
// //                                     <Collapse in={isSelected && dropdownOpen} timeout="auto" unmountOnExit>
// //                                         <List component="div" disablePadding sx={{marginBottom:"50px"}}>
// //                                             {dropdownContent.map((dropdownItem, idx) => (
// //                                                 <ListItemButton
// //                                                     key={idx}
// //                                                     sx={{
// //                                                         pl: 4,
// //                                                         background: location.pathname === dropdownItem.route ? "#A055B0" : "#B276C3",
// //                                                         borderRadius: "20px",
// //                                                         marginBottom: "10px",
// //                                                         color: "#fff",
// //                                                         "&:hover": { background: "#A055B0" },
// //                                                         padding: "10px 16px",
// //                                                         marginLeft: "8px",
// //                                                         marginRight: "8px",
// //                                                     }}
// //                                                     onClick={() => handleDropdownItemClick(dropdownItem.route)}
// //                                                 >
// //                                                     <Box sx={{
// //                                                         color: "#fff",
// //                                                         minWidth: "27px",
// //                                                         display: "flex",
// //                                                         alignItems: "center",
// //                                                         justifyContent: "center"
// //                                                     }}>
// //                                                         {renderIcon(dropdownItem.icon, "small")}
// //                                                     </Box>
// //                                                     <ListItemText
// //                                                         primary={dropdownItem.text}
// //                                                         primaryTypographyProps={{
// //                                                             style: {
// //                                                                 fontSize: getTextSize() === "11px" ? "10px" :
// //                                                                     getTextSize() === "12px" ? "11px" : "12px",
// //                                                                 fontWeight: "bold",
// //                                                             },
// //                                                         }}
// //                                                     />
// //                                                 </ListItemButton>
// //                                             ))}
// //                                         </List>
// //                                     </Collapse>
// //                                 </Box>
// //                             )
// //                         );
// //                     })}
// //                 </Box>
// //             </Drawer>
// //         </>
// //     );
// // };

// // export default LandingSideBar2;







// import React, { useState, useEffect } from "react";
// import {
//     Box,
//     IconButton,
//     List,
//     ListItem,
//     ListItemButton,
//     ListItemText,
//     Drawer,
//     useMediaQuery,
//     useTheme,
//     Collapse,
// } from "@mui/material";
// import { useNavigate, useLocation } from "react-router-dom";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// import {
//     Home as HomeIcon,
//     RestaurantMenu as RestaurantMenuIcon,
//     Apartment as ApartmentIcon,
//     Settings as SettingsIcon,
//     Dashboard as DashboardIcon,
//     DinnerDining as DinnerDiningIcon,
//     Payment as PaymentIcon,
//     Assessment as AssessmentIcon,
//     Dashboard
// } from "@mui/icons-material";
// import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// import ExpandLess from "@mui/icons-material/ExpandLess";
// import ExpandMore from "@mui/icons-material/ExpandMore";
// import {
//     FaUtensils,
//     FaConciergeBell,
//     FaShoppingBasket,
//     FaBuilding
// } from "react-icons/fa";

// import {
//     Building, Settings, Utensils, ShoppingBag,
//     ChefHat, Truck, User, Tag,
//     Table, Package, BarChart, Home, Users, Star, Headphones, Bell, FileText
// } from 'lucide-react';
// import { text } from "framer-motion/client";

// // All possible menu items - these will only open dropdowns, not navigate
// const allMenuItems = [
//     // { text: "Subscription", icon: <HomeIcon />, vertical: "SUBSCRIPTION" },
//     { text: "Food & Beverages", route: "/foodladingpage", vertical: "FOOD_AND_BEVERAGES" },
//     { text: "Catering & Services", icon: <RestaurantMenuIcon />, vertical: "CATERINGS_SERVICES" },
//     // { text: "Logistics & Supply", icon: <LocalShippingIcon />, vertical: "LOGISTICS_SUPPLY" },
//     // { text: "Fresh & Grocery", icon: <ShoppingBasketIcon />, vertical: "FRESH_GROCERIES" }
// ];



// const subscriptionEnumToMenuItemMap = {
//     Food_Beverages: {
//         text: "Food & Beverages",
//         icon: FaUtensils,
//         route: "/mainladdingpage?vertical=food"
//     },
//     Catering_Services: {
//         text: "Catering & Services",
//         icon: FaConciergeBell,
//         route: "/mainladdingpage?vertical=catering"
//     },
//     Fresh_Grocery: {
//         text: "Fresh & Grocery",
//         icon: FaShoppingBasket,
//         route: "/mainladdingpage?vertical=grocery"
//     },
//     Logistics_Supply: {
//         text: "Logistics & Supply",
//         icon: LocalShippingIcon,
//         route: "/mainladdingpage?vertical=logistics"
//     },
//     Banquet_Hall: {
//         text: "Banquet Hall",
//         icon: FaBuilding,
//         route: "/mainladdingpage?vertical=banquet"
//     },
// };

// // Your actual dropdown content mapping with safe icon handling
// const enumToMenuItemMap = {
//     Dashboard: {
//         text: "Dashboard", icon: HomeIcon,
//         route: "/fooddashboard"
//     },
//     // Home: { text: "Home", icon: HomeIcon, route: "/foodladingpage" },
//     Company: { text: "Business Profile", icon: Building, route: "/foodbeveragescompany" },
//     Settings_Controls: {
//         text: "Settings & Control",
//         icon: Settings,
//         route: "/foodsettings"
//     },
//     Menu_Management: {
//         text: "Services & Products",
//         icon: Utensils,
//         route: "/foodandbeveragesMenu"
//     },
//     Inventory_Management: {
//         text: "Inventory",
//         icon: Package,
//         route: "/foodandbeveragesInvetory"
//     },
//     Order_Management: {
//         text: "Order",
//         icon: ShoppingBag,
//         route: "/foodordermanagment"
//     },
//     Chef_Management: {
//         text: "Chef",
//         icon: ChefHat,
//         route: "/foodchefmanagment"
//     },
//     Table_Management: {
//         text: "Table",
//         icon: Table,
//         route: "/foodtablemanagment"
//     },
//     Delivery_Management: {
//         text: "Delivery",
//         icon: DinnerDiningIcon,
//         route: "/foodwaitermanagment"
//     },
//     Team_Managment: { text: "Team", icon: Users, route: "/teammanagment" },
//     Account_History: {
//         text: "Account & History",
//         icon: User,
//         route: "/foodAccuontdata"
//     },
//     // Subscriptions: {
//     //     text: "Subscription plans",
//     //     route: "/subscriptionpackages"
//     // },
//     Promotions_Discounts: {
//         text: "Promotions",
//         icon: Tag,
//         route: "/foodandbeveragespromotions"
//     },
//     Ratings_Reviews: {
//         text: "Ratings & Reviews",
//         icon: Star,
//         route: "/foodratings"
//     },
//     Support_System: {
//         text: "Support System",
//         icon: Headphones,
//         route: "/foodandbeveragessupportsystem"
//     },
//     Legal_Compliance: {
//         text: "Leagl & Complaince",
//         icon: FileText,
//         route: "/foodsupportsystem"
//     },
//     Notification: {
//         text: "Notification",
//         icon: Bell,
//         route: "/notificationcontext"
//     },
//     Report_Analysis: {
//         text: "Report & Analysis",
//         icon: BarChart ,
//         route: "/foodandreporanalysis"
//     },
// };

// const cateringEnumToMenuItemMap = {
//     Dashboard: { text: "Dashboard", route: "/cateringdashboard" },
//     // Home: { text: "Home", icon: HomeIcon, route: "/cateringlading" },
//     Company: { text: "Profile", icon: ApartmentIcon, route: "/cateringsprofilepage" },
//     Settings_Controls: {
//         text: "Settings & Control",
//         icon: SettingsIcon,
//         route: "/cateringssettingpage"
//     },
//     Menu_Management: {
//         text: "Services & Products",
//         icon: RestaurantMenuIcon,
//         route: "/cateringsmenuaddingpage"
//     },
//     Order_Management: {
//         text: "Leads Orders",
//         icon: DashboardIcon,
//         route: "/cateringsorderspage"
//     },
//     Table_Management: {
//         text: "Package Orders",
//         icon: DashboardIcon,
//         route: "/cateringpackageorders"
//     },
//     Account_History: {
//         text: "Account & History",
//         icon: PaymentIcon,
//         route: "/caterigsaccount"
//     },

//     Promotions_Discounts: {
//         text: "Promotions",
//         icon: PaymentIcon,
//         route: "/cateringspromotionspage"
//     },
//     Report_Analysis: {
//         text: "Report & Analysis",
//         icon: AssessmentIcon,
//         route: "/cateringsreportanalysis"
//     },
// }

// const groceryEnumMenuToMap = {
//     Home: { text: "Home", icon: HomeIcon, route: "/groceryladingpage" },
//     Company: { text: "Profile", icon: ApartmentIcon, route: "/groceryprofiledata" },
//     Settings_Controls: {
//         text: "Settings & Control",
//         icon: SettingsIcon,
//         route: "/grocerysettingsdata"
//     },
//     Menu_Management: {
//         text: "Menu",
//         icon: RestaurantMenuIcon,
//         route: "/groceryandbeveragesMenu"
//     },
//     Order_Management: {
//         text: "Order",
//         icon: DashboardIcon,
//         route: "/groceryorders"
//     },
//     Account_History: {
//         text: "Account & History",
//         icon: PaymentIcon,
//         route: "/groceryaccuontdata"
//     },
//     Promotions_Discounts: {
//         text: "Promotions",
//         icon: PaymentIcon,
//         route: "/groceryandbeveragespromotions"
//     },
//     Inventory_Management: { text: "Inventory", icon: PaymentIcon, route: "/groceryandbeveragesInvetory" },
//     Report_Analysis: {
//         text: "Report & Analysis",
//         icon: AssessmentIcon,
//         route: "/groceryandreporanalysis"
//     },
// }

// const LandingSideBar2 = () => {
//     const [open, setOpen] = useState(false);
//     const [menuItems, setMenuItems] = useState([]);
//     const [dropdownOpen, setDropdownOpen] = useState(false);
//     const [selectedItem, setSelectedItem] = useState(null);
//     const [allowedModules, setAllowedModules] = useState([]);
//     const [allowedBusinessVerticals, setAllowedBusinessVerticals] = useState([]);
//     const [filteredMenuItems, setFilteredMenuItems] = useState([]); // NEW: For permission-based filtering
//     const navigate = useNavigate();
//     const location = useLocation();
//     const theme = useTheme();


//     // Media queries
//     const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//     const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));
//     const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
//     const isBelow500 = useMediaQuery("(max-width:500px)");
//     const isBelow1315 = useMediaQuery("(max-width:1315px)");
//     const isBetween1315And1399 = useMediaQuery("(min-width:1315px) and (max-width:1399px)");
//     const isAbove1400 = useMediaQuery("(min-width:1450px)");

//     // Your custom window width detection
//     const isMobilee = window.innerWidth < 600;        // < 600px
//     const isTablett = window.innerWidth >= 600 && window.innerWidth < 999; // 600px - 999px
//     const isDesktopp = window.innerWidth >= 999;          // > 999px

//     const showHamburger = isMobilee || isTablett; // true for mobile AND tablet

//     let drawerWidth = 189; // default

//     if (isBelow500) {
//         drawerWidth = 250;
//     } else if (isBelow1315) {
//         drawerWidth = 170;
//     } else if (isBetween1315And1399) {
//         drawerWidth = 180;
//     } else if (isAbove1400) {
//         drawerWidth = 215;
//     }

//     const getIconSize = () => (isMobile ? "small" : "medium");
//     const getTextSize = () => (isMobile ? "12px" : isTablet ? "0.8rem" : "0.9rem");

//     // Set initial open state based on your custom window width detection
//     useEffect(() => {
//         if (showHamburger) {
//             setOpen(false); // Closed by default on mobile/tablet
//         } else {
//             setOpen(true);  // Always open on desktop
//         }
//     }, [showHamburger]);

//     // Permission-based module filtering - FROM REFERENCE FILE
//     useEffect(() => {
//         const employeeId = localStorage.getItem("employeeId");

//         // Get login data
//         const loginData = JSON.parse(localStorage.getItem("loginResponse") || "{}");
//         const modulesFromResponse = loginData?.modules || [];
//         const planTypes = loginData?.planTypes || [];
//         const businessVerticalsFromResponse = loginData?.businessVerticals || [];

//         let filteredModules = [];
//         let filteredBusinessVerticals = [];

//         if (employeeId && employeeId !== "0") {
//             // Employee → show only modules from login response
//             filteredModules = modulesFromResponse.map(m => m.trim().replace(/\s+/g, "_"));
//             filteredBusinessVerticals = businessVerticalsFromResponse;
//         } else {
//             // Parent vendor → show modules depending on plan type
//             if (planTypes.includes("BASIC")) {
//                 // BASIC has highest priority
//                 filteredModules = [
//                     "Dashboard",
//                     "Company",
//                     "Team_Managment",
//                     "Home",
//                     "Settings_Controls",
//                     "Order_Management",
//                     "Menu_Management",
//                     "Account_History",
//                     "Report_Analysis",
//                     "Promotions_Discounts",
//                     "Notification",
//                 ];
//                 filteredBusinessVerticals = ["FOOD_AND_BEVERAGES", "CATERINGS_SERVICES"];
//             } else if (planTypes.includes("PREMIUM")) {
//                 filteredModules = Object.keys(enumToMenuItemMap); // all modules
//                 filteredBusinessVerticals = businessVerticalsFromResponse;
//             } else if (planTypes.includes("STANDARD")) {
//                 filteredModules = modulesFromResponse.length > 0
//                     ? modulesFromResponse.map(m => m.trim().replace(/\s+/g, "_"))
//                     : ["Home", "Order_Management"];
//                 filteredBusinessVerticals = businessVerticalsFromResponse;
//             } else {
//                 filteredModules = ["Home", "Order_Management"];
//                 filteredBusinessVerticals = businessVerticalsFromResponse;
//             }
//         }

//         // console.log("✅ Allowed modules:", filteredModules);
//         // console.log("✅ Allowed businessVerticals:", filteredBusinessVerticals);

//         setAllowedModules(filteredModules);
//         setAllowedBusinessVerticals(filteredBusinessVerticals);

//         // NEW: Apply permission filtering to menu items - FROM REFERENCE FILE
//         const permissionFilteredItems = Object.keys(enumToMenuItemMap)
//             .filter((key) => filteredModules.includes(key))
//             .map((key) => enumToMenuItemMap[key]);

//         setFilteredMenuItems(permissionFilteredItems);
//         //console.log("✅ Permission filtered menu items:", permissionFilteredItems);

//     }, []);

//     // Filter menu items based on business verticals
//     useEffect(() => {
//         const loginData = JSON.parse(localStorage.getItem("loginResponse"));
//         const businessVerticals = loginData?.businessVerticals || [];

//         const filteredMenu = allMenuItems.filter(
//             (item) =>
//                 item.text === "Subscription" || businessVerticals.includes(item.vertical)
//         );

//         setMenuItems(filteredMenu);
//     }, []);

//     const handleMenuItemClick = (item) => {
//         // Toggle dropdown - only open/close dropdown, no navigation
//         if (selectedItem?.text === item.text) {
//             setDropdownOpen(!dropdownOpen);
//         } else {
//             setSelectedItem(item);
//             setDropdownOpen(true);
//         }
//     };

//     const handleDropdownItemClick = (route) => {
//         // This will handle navigation for dropdown items
//         navigate(route);
//         if (isMobile) setOpen(false);
//         // setDropdownOpen(false); // Close dropdown after navigation
//     };

//     // Safe icon renderer function
//     const renderIcon = (IconComponent, size) => {
//         if (!IconComponent || typeof IconComponent === 'undefined') {
//             return <DashboardIcon fontSize={size} />; // Fallback icon
//         }
//         return <IconComponent fontSize={size} />;
//     };

//     // Filter dropdown content based on allowed modules - UPDATED with permission filtering
//     const getDropdownContent = (item) => {
//         let dropdownItems = [];

//         switch (item.text) {
//             case "Food & Beverages":
//                 // NEW: Use permission-filtered items instead of all items
//                 dropdownItems = filteredMenuItems.length > 0 ? filteredMenuItems : Object.values(enumToMenuItemMap);
//                 break;
//             case "Subscription":
//                 dropdownItems = Object.values(subscriptionEnumToMenuItemMap);
//                 break;
//             case "Catering & Services":
//                 dropdownItems = Object.values(cateringEnumToMenuItemMap);
//                 break;
//             case "Logistics & Supply":
//                 dropdownItems = [
//                     { text: "Shipping", icon: LocalShippingIcon, route: "/shipping" },
//                     { text: "Warehouse", icon: LocalShippingIcon, route: "/warehouse" },
//                 ];
//                 break;
//             case "Fresh & Grocery":
//                 dropdownItems = Object.values(groceryEnumMenuToMap);
//                 break;
//             default:
//                 dropdownItems = [];
//         }

//         // Additional filtering based on allowed modules for cross-vertical consistency
//         return dropdownItems.filter(dropdownItem => {
//             // Find the module key that matches this dropdown item
//             const moduleKey = Object.keys(enumToMenuItemMap).find(key =>
//                 enumToMenuItemMap[key].text === dropdownItem.text
//             );

//             // If we found a module key, check if it's allowed
//             // If no module key found (different vertical), allow it
//             return !moduleKey || allowedModules.includes(moduleKey);
//         });
//     };

//     return (
//         <>
//             {/* Open Panel Button - Only show when panel is closed */}
//             {!open && (
//                 <Box
//                     sx={{
//                         position: "fixed",
//                         top: isMobile ? "12%" : "150px",
//                         left: isMobile ? "10px" : "10px",
//                         zIndex: 1500,
//                         display: window.innerWidth <= 900 ? "block" : "none",
//                     }}
//                 >
//                     <IconButton
//                         onClick={() => setOpen(true)}
//                         sx={{
//                             color: "#b15cd6",
//                             backgroundColor: "white",
//                             boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                             '&:hover': {
//                                 backgroundColor: "#f5f5f5",
//                             },
//                             height: "25px",
//                             width: "25px",
//                         }}
//                     >
//                         <ArrowForwardIosIcon />
//                     </IconButton>
//                 </Box>
//             )}

//             <Drawer
//                 anchor="left"
//                 variant={showHamburger ? "temporary" : "persistent"}
//                 open={open}
//                 onClose={showHamburger ? () => setOpen(false) : undefined}
//                 PaperProps={{
//                     sx: {
//                         marginTop: isMobile ? "52px" : "118px",
//                         height: isMobile ? "calc(100vh - 50px)" : "calc(100vh - 50px)",
//                         width: drawerWidth,
//                         scrollbarWidth: "none",
//                         backgroundColor: "#fff",
//                         border: "3px solid white",
//                         overflow: 'hidden',
//                         '&::-webkit-scrollbar': {
//                             display: 'none'
//                         },
//                         scrollbarWidth: 'none',
//                         '-ms-overflow-style': 'none',
//                         zIndex: 1001,
//                         left: "00px",
//                     },
//                 }}
//                 ModalProps={{ keepMounted: true }}
//             >
//                 {/* Single scrollable container for everything */}
//                 <Box sx={{
//                     height: '100%',
//                     overflowY: 'auto',
//                     '&::-webkit-scrollbar': { display: 'none' },
//                     scrollbarWidth: 'none',
//                     '-ms-overflow-style': 'none',
//                     paddingBottom: '20px'
//                 }}>
//                     <List sx={{ paddingTop: "8px", paddingBottom: "60px" }}>
//                         {menuItems.map((item, index) => {
//                             const isSelected = selectedItem?.text === item.text;
//                             const dropdownContent = getDropdownContent(item);

//                             return (
//                                 <React.Fragment key={index}>
//                                     {/* MAIN BUTTON */}
//                                     <ListItem disablePadding sx={{ marginTop: "0px", marginBottom: "0px" }}>
//                                         <ListItemButton
//                                             sx={{
//                                                 background: isSelected ? "#A055B0" : "#B276C3",
//                                                 borderRadius: "20px",
//                                                 marginBottom: "10px",
//                                                 color: "#fff",
//                                                 "&:hover": { background: "#A055B0" },
//                                                 padding: "10px 16px",
//                                                 position: "relative",
//                                                 marginLeft: "8px",
//                                                 marginRight: "8px",
//                                             }}
//                                             onClick={() => handleMenuItemClick(item)}
//                                         >
//                                             {/* Close button */}
//                                             {open && (
//                                                 <IconButton
//                                                     size="small"
//                                                     onClick={(e) => {
//                                                         e.stopPropagation();
//                                                         setOpen(false);
//                                                     }}
//                                                     sx={{
//                                                         color: "#fff",
//                                                         position: "absolute",
//                                                         left: "5px",
//                                                         top: "45%",
//                                                         transform: "translateY(-50%)",
//                                                         backgroundColor: "rgba(255,255,255,0)",
//                                                         '&:hover': { backgroundColor: "rgba(255,255,255,0)" },
//                                                         marginRight: "5px",
//                                                         display: window.innerWidth <= 990 ? "block" : "none",
//                                                     }}
//                                                 >
//                                                     <ArrowBackIosIcon fontSize="small" />
//                                                 </IconButton>
//                                             )}

//                                             <ListItemText
//                                                 primary={item.text}
//                                                 primaryTypographyProps={{
//                                                     style: {
//                                                         fontSize: getTextSize(),
//                                                         fontWeight: "bold",
//                                                         marginLeft: window.innerWidth <= 990 ? "10px" : "0px",
//                                                     },
//                                                 }}
//                                             />

//                                             {dropdownContent.length > 0 && (
//                                                 isSelected && dropdownOpen ? <ExpandLess /> : <ExpandMore />
//                                             )}
//                                         </ListItemButton>
//                                     </ListItem>

//                                     {/* DROPDOWN LINKS for THIS BUTTON ONLY */}
//                                     {isSelected && dropdownOpen && dropdownContent.length > 0 && (
//                                         <Box sx={{ paddingLeft: "16px", paddingRight: "16px", marginBottom: "10px" }}>
//                                             {dropdownContent.map((dropdownItem, idx) => (
//                                                 <ListItemButton
//                                                     key={idx}
//                                                     sx={{
//                                                         pl: 4,
//                                                         background: location.pathname === dropdownItem.route ? "#A055B0" : "#B276C3",
//                                                         borderRadius: "20px",
//                                                         marginBottom: "8px",
//                                                         color: "#fff",
//                                                         "&:hover": { background: "#A055B0" },
//                                                         padding: "8px 16px",
//                                                     }}
//                                                     onClick={() => handleDropdownItemClick(dropdownItem.route)}
//                                                 >
//                                                     <Box sx={{
//                                                         color: "#fff",
//                                                         minWidth: "27px",
//                                                         display: "flex",
//                                                         alignItems: "center",
//                                                         justifyContent: "center"
//                                                     }}>
//                                                         {renderIcon(dropdownItem.icon, "small")}
//                                                     </Box>
//                                                     <ListItemText
//                                                         primary={dropdownItem.text}
//                                                         primaryTypographyProps={{
//                                                             style: {
//                                                                 fontSize: getTextSize() === "11px" ? "10px" :
//                                                                     getTextSize() === "12px" ? "11px" : "12px",
//                                                                 fontWeight: "bold",
//                                                             },
//                                                         }}
//                                                     />
//                                                 </ListItemButton>
//                                             ))}
//                                         </Box>
//                                     )}
//                                 </React.Fragment>
//                             );
//                         })}
//                     </List>
//                 </Box>
//             </Drawer>
//         </>
//     );
// };

// export default LandingSideBar2;









// import React, { useState, useEffect } from "react";
// import {
//     Box,
//     IconButton,
//     List,
//     ListItem,
//     ListItemButton,
//     ListItemText,
//     Drawer,
//     useMediaQuery,
//     useTheme,
//     Collapse,
// } from "@mui/material";
// import { useNavigate, useLocation } from "react-router-dom";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// import {
//     Home as HomeIcon,
//     RestaurantMenu as RestaurantMenuIcon,
//     Apartment as ApartmentIcon,
//     Settings as SettingsIcon,
//     Dashboard as DashboardIcon,
//     DinnerDining as DinnerDiningIcon,
//     Payment as PaymentIcon,
//     Assessment as AssessmentIcon,
//     Dashboard
// } from "@mui/icons-material";
// import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// import ExpandLess from "@mui/icons-material/ExpandLess";
// import ExpandMore from "@mui/icons-material/ExpandMore";
// import {
//     FaUtensils,
//     FaConciergeBell,
//     FaShoppingBasket,
//     FaBuilding
// } from "react-icons/fa";
// import { Table } from "lucide-react";

// // All possible menu items - these will only open dropdowns, not navigate
// const allMenuItems = [
//     // { text: "Subscription", icon: <HomeIcon />, vertical: "SUBSCRIPTION" },
//     { text: "Food & Beverages", route: "/foodladingpage", vertical: "FOOD_AND_BEVERAGES" },
//     { text: "Catering & Services", icon: <RestaurantMenuIcon />, vertical: "FOOD_AND_BEVERAGES" },
//     // { text: "Logistics & Supply", icon: <LocalShippingIcon />, vertical: "LOGISTICS_SUPPLY" },
//     // { text: "Fresh & Grocery", icon: <ShoppingBasketIcon />, vertical: "FRESH_GROCERIES" }
// ];

// const subscriptionEnumToMenuItemMap = {
//     Food_Beverages: {
//         text: "Food & Beverages",
//         icon: FaUtensils,
//         route: "/mainladdingpage?vertical=food"
//     },
//     Catering_Services: {
//         text: "Catering & Services",
//         icon: FaConciergeBell,
//         route: "/mainladdingpage?vertical=catering"
//     },
//     Fresh_Grocery: {
//         text: "Fresh & Grocery",
//         icon: FaShoppingBasket,
//         route: "/mainladdingpage?vertical=grocery"
//     },
//     Logistics_Supply: {
//         text: "Logistics & Supply",
//         icon: LocalShippingIcon,
//         route: "/mainladdingpage?vertical=logistics"
//     },
//     Banquet_Hall: {
//         text: "Banquet Hall",
//         icon: FaBuilding,
//         route: "/mainladdingpage?vertical=banquet"
//     },
// };

// // Your actual dropdown content mapping with safe icon handling
// const enumToMenuItemMap = {
//     Dashboard: {
//         text: "Dashboard", icon: HomeIcon,
//         route: "/fooddashboard"
//     },
//     // Home: { text: "Home", icon: HomeIcon, route: "/foodladingpage" },
//     Company: { text: "Business Profile", icon: ApartmentIcon, route: "/foodbeveragescompany" },
//     Team_Managment: {text: "Team", route: "/teammanagment"},
//     Settings_Controls: {
//         text: "Settings & Control",
//         icon: SettingsIcon,
//         route: "/foodsettings"
//     },
//     Menu_Management: {
//         text: "Menu",
//         icon: RestaurantMenuIcon,
//         route: "/foodandbeveragesMenu"
//     },
//     Order_Management: {
//         text: "Order",
//         icon: DashboardIcon,
//         route: "/foodordermanagment"
//     },
//     Chef_Management: {
//         text: "Chef",
//         icon: RestaurantMenuIcon,
//         route: "/foodchefmanagment"
//     },
//     Delivery_Management: {
//         text: "Delivery",
//         icon: DinnerDiningIcon,
//         route: "/foodwaitermanagment"
//     },
//     Account_History: {
//         text: "Account & History",
//         icon: PaymentIcon,
//         route: "/foodAccuontdata"
//     },
//     Promotions_Discounts: {
//         text: "Promotions",
//         icon: PaymentIcon,
//         route: "/foodandbeveragespromotions"
//     },
//     Table_Management: {
//         text: "Table",
//         icon: AssessmentIcon,
//         route: "/foodtablemanagment"
//     },
//     // Inventory_Management: {
//     //     text: "Inventory",
//     //     icon: PaymentIcon,
//     //     route: "/foodandbeveragesInvetory"
//     // },
//     Report_Analysis: {
//         text: "Report & Analysis",
//         icon: AssessmentIcon,
//         route: "/foodandreporanalysis"
//     },
//     // Support_System: {
//     //     text: "Support System",
//     //     route: "/foodsupportsystem"
//     // },
//     Legal_Compliance: {
//         text: "Leagl & Complaince",
//         route: "/foodsupportsystem"
//     }
// };

// const cateringEnumToMenuItemMap = {
//     Home: { text: "Home", icon: HomeIcon, route: "/cateringlading" },
//     Company: { text: "Profile", icon: ApartmentIcon, route: "/cateringsprofilepage" },
//     Settings_Controls: {
//         text: "Settings & Control",
//         icon: SettingsIcon,
//         route: "/cateringssettingpage"
//     },
//     Menu_Management: {
//         text: "Menu",
//         icon: RestaurantMenuIcon,
//         route: "/cateringsmenuaddingpage"
//     },
//     Order_Management: {
//         text: "Leads Orders",
//         icon: DashboardIcon,
//         route: "/cateringsorderspage"
//     },
//     Table_Management: {
//         text: "Package Orders",
//         icon: DashboardIcon,
//         route: "/cateringpackageorders"
//     },
//     Account_History: {
//         text: "Account & History",
//         icon: PaymentIcon,
//         route: "/caterigsaccount"
//     },
//     Promotions_Discounts: {
//         text: "Promotions",
//         icon: PaymentIcon,
//         route: "/cateringspromotionspage"
//     },
//     Report_Analysis: {
//         text: "Report & Analysis",
//         icon: AssessmentIcon,
//         route: "/cateringsreportanalysis"
//     },
// }

// const groceryEnumMenuToMap = {
//     Home: { text: "Home", icon: HomeIcon, route: "/groceryladingpage" },
//     Company: { text: "Profile", icon: ApartmentIcon, route: "/groceryprofiledata" },
//     Settings_Controls: {
//         text: "Settings & Control",
//         icon: SettingsIcon,
//         route: "/grocerysettingsdata"
//     },
//     Menu_Management: {
//         text: "Menu",
//         icon: RestaurantMenuIcon,
//         route: "/groceryandbeveragesMenu"
//     },
//     Order_Management: {
//         text: "Order",
//         icon: DashboardIcon,
//         route: "/groceryorders"
//     },
//     Account_History: {
//         text: "Account & History",
//         icon: PaymentIcon,
//         route: "/groceryaccuontdata"
//     },
//     Promotions_Discounts: {
//         text: "Promotions",
//         icon: PaymentIcon,
//         route: "/groceryandbeveragespromotions"
//     },
//     Inventory_Management: { text: "Inventory", icon: PaymentIcon, route: "/groceryandbeveragesInvetory" },
//     Report_Analysis: {
//         text: "Report & Analysis",
//         icon: AssessmentIcon,
//         route: "/groceryandreporanalysis"
//     },
// }

// const LandingSideBar2 = () => {
//     const [open, setOpen] = useState(false);
//     const [menuItems, setMenuItems] = useState([]);
//     const [dropdownOpen, setDropdownOpen] = useState(false);
//     const [selectedItem, setSelectedItem] = useState(null);
//     const [allowedModules, setAllowedModules] = useState([]);
//     const [allowedBusinessVerticals, setAllowedBusinessVerticals] = useState([]);
//     const [filteredMenuItems, setFilteredMenuItems] = useState([]); // NEW: For permission-based filtering
//     const navigate = useNavigate();
//     const location = useLocation();
//     const theme = useTheme();

//     // Media queries
//     const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//     const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));
//     const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
//     const isBelow500 = useMediaQuery("(max-width:500px)");
//     const isBelow1315 = useMediaQuery("(max-width:1315px)");
//     const isBetween1315And1399 = useMediaQuery("(min-width:1315px) and (max-width:1399px)");
//     const isAbove1400 = useMediaQuery("(min-width:1450px)");

//     // Your custom window width detection
//     const isMobilee = window.innerWidth < 600;        // < 600px
//     const isTablett = window.innerWidth >= 600 && window.innerWidth < 999; // 600px - 999px
//     const isDesktopp = window.innerWidth >= 999;          // > 999px

//     const showHamburger = isMobilee || isTablett; // true for mobile AND tablet

//     let drawerWidth = 189; // default

//     if (isBelow500) {
//         drawerWidth = 250;
//     } else if (isBelow1315) {
//         drawerWidth = 176;
//     } else if (isBetween1315And1399) {
//         drawerWidth = 190;
//     } else if (isAbove1400) {
//         drawerWidth = 208;
//     }

//     const getIconSize = () => (isMobile ? "small" : "medium");
//     const getTextSize = () => (isMobile ? "12px" : isTablet ? "0.8rem" : "1rem");

//     // Set initial open state based on your custom window width detection
//     useEffect(() => {
//         if (showHamburger) {
//             setOpen(false); // Closed by default on mobile/tablet
//         } else {
//             setOpen(true);  // Always open on desktop
//         }
//     }, [showHamburger]);

//     // Permission-based module filtering - FROM REFERENCE FILE
//     useEffect(() => {
//         const employeeId = localStorage.getItem("employeeId");

//         // Get login data
//         const loginData = JSON.parse(localStorage.getItem("loginResponse") || "{}");
//         const modulesFromResponse = loginData?.modules || [];
//         const planTypes = loginData?.planTypes || [];
//         const businessVerticalsFromResponse = loginData?.businessVerticals || [];

//         let filteredModules = [];
//         let filteredBusinessVerticals = [];

//         if (employeeId && employeeId !== "0") {
//             // Employee → show only modules from login response
//             filteredModules = modulesFromResponse.map(m => m.trim().replace(/\s+/g, "_"));
//             filteredBusinessVerticals = businessVerticalsFromResponse;
//         } else {
//             // Parent vendor → show modules depending on plan type
//             if (planTypes.includes("BASIC")) {
//                 // BASIC has highest priority
//                 filteredModules = [
//                     "Dashboard",
//                     "Company",
//                     "Team_Managment",
//                     "Home",
//                     "Settings_Controls",
//                     "Order_Management",
//                     "Menu_Management",
//                     "Account_History",
//                     "Report_Analysis",
//                     "Promotions_Discounts"
//                 ];
//                 filteredBusinessVerticals = ["FOOD_AND_BEVERAGES", "CATERINGS_SERVICES"];
//             } else if (planTypes.includes("PREMIUM")) {
//                 filteredModules = Object.keys(enumToMenuItemMap); // all modules
//                 filteredBusinessVerticals = businessVerticalsFromResponse;
//             } else if (planTypes.includes("STANDARD")) {
//                 filteredModules = modulesFromResponse.length > 0
//                     ? modulesFromResponse.map(m => m.trim().replace(/\s+/g, "_"))
//                     : ["Home", "Order_Management"];
//                 filteredBusinessVerticals = businessVerticalsFromResponse;
//             } else {
//                 filteredModules = ["Home", "Order_Management"];
//                 filteredBusinessVerticals = businessVerticalsFromResponse;
//             }
//         }

//         // console.log("✅ Allowed modules:", filteredModules);
//         // console.log("✅ Allowed businessVerticals:", filteredBusinessVerticals);

//         setAllowedModules(filteredModules);
//         setAllowedBusinessVerticals(filteredBusinessVerticals);

//         // NEW: Apply permission filtering to menu items - FROM REFERENCE FILE
//         const permissionFilteredItems = Object.keys(enumToMenuItemMap)
//             .filter((key) => filteredModules.includes(key))
//             .map((key) => enumToMenuItemMap[key]);

//         setFilteredMenuItems(permissionFilteredItems);
//         //console.log("✅ Permission filtered menu items:", permissionFilteredItems);

//     }, []);

//     // Filter menu items based on business verticals
//     useEffect(() => {
//         const loginData = JSON.parse(localStorage.getItem("loginResponse"));
//         const businessVerticals = loginData?.businessVerticals || [];

//         const filteredMenu = allMenuItems.filter(
//             (item) =>
//                 item.text === "Subscription" || businessVerticals.includes(item.vertical)
//         );

//         setMenuItems(filteredMenu);
//     }, []);

//     const handleMenuItemClick = (item) => {
//         // Toggle dropdown - only open/close dropdown, no navigation
//         if (selectedItem?.text === item.text) {
//             setDropdownOpen(!dropdownOpen);
//         } else {
//             setSelectedItem(item);
//             setDropdownOpen(true);
//         }
//     };

//     const handleDropdownItemClick = (route) => {
//         // This will handle navigation for dropdown items
//         navigate(route);
//         if (isMobile) setOpen(false);
//         // setDropdownOpen(false); // Close dropdown after navigation
//     };

//     // Safe icon renderer function
//     const renderIcon = (IconComponent, size) => {
//         if (!IconComponent || typeof IconComponent === 'undefined') {
//             return <DashboardIcon fontSize={size} />; // Fallback icon
//         }
//         return <IconComponent fontSize={size} />;
//     };

//     // Filter dropdown content based on allowed modules - UPDATED with permission filtering
//     const getDropdownContent = (item) => {
//         let dropdownItems = [];

//         switch (item.text) {
//             case "Food & Beverages":
//                 // NEW: Use permission-filtered items instead of all items
//                 dropdownItems = filteredMenuItems.length > 0 ? filteredMenuItems : Object.values(enumToMenuItemMap);
//                 break;
//             case "Subscription":
//                 dropdownItems = Object.values(subscriptionEnumToMenuItemMap);
//                 break;
//             case "Catering & Services":
//                 dropdownItems = Object.values(cateringEnumToMenuItemMap);
//                 break;
//             case "Logistics & Supply":
//                 dropdownItems = [
//                     { text: "Shipping", icon: LocalShippingIcon, route: "/shipping" },
//                     { text: "Warehouse", icon: LocalShippingIcon, route: "/warehouse" },
//                 ];
//                 break;
//             case "Fresh & Grocery":
//                 dropdownItems = Object.values(groceryEnumMenuToMap);
//                 break;
//             default:
//                 dropdownItems = [];
//         }

//         // Additional filtering based on allowed modules for cross-vertical consistency
//         return dropdownItems.filter(dropdownItem => {
//             // Find the module key that matches this dropdown item
//             const moduleKey = Object.keys(enumToMenuItemMap).find(key =>
//                 enumToMenuItemMap[key].text === dropdownItem.text
//             );

//             // If we found a module key, check if it's allowed
//             // If no module key found (different vertical), allow it
//             return !moduleKey || allowedModules.includes(moduleKey);
//         });
//     };

//     return (
//         <>
//             {/* Open Panel Button - Only show when panel is closed */}
//             {!open && (
//                 <Box
//                     sx={{
//                         position: "fixed",
//                         top: isMobile ? "12%" : "150px",
//                         left: isMobile ? "10px" : "10px",
//                         zIndex: 1500,
//                         display: window.innerWidth <= 900 ? "block" : "none",
//                     }}
//                 >
//                     <IconButton
//                         onClick={() => setOpen(true)}
//                         sx={{
//                             color: "#b15cd6",
//                             backgroundColor: "white",
//                             boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                             '&:hover': {
//                                 backgroundColor: "#f5f5f5",
//                             },
//                             height:"25px",
//                             width:"25px",
//                         }}
//                     >
//                         <ArrowForwardIosIcon />
//                     </IconButton>
//                 </Box>
//             )}

//             <Drawer
//                 anchor="left"
//                 variant={showHamburger ? "temporary" : "persistent"}
//                 open={open}
//                 onClose={showHamburger ? () => setOpen(false) : undefined}
//                 PaperProps={{
//                     sx: {
//                         marginTop: isMobile ? "52px" : "118px",
//                         height: isMobile ? "calc(100vh - 50px)" : "calc(100vh - 50px)",
//                         width: drawerWidth,
//                         scrollbarWidth: "none",
//                         backgroundColor: "#fff",
//                         border: "3px solid white",
//                         overflow: 'hidden', // Changed from auto to hidden
//                         '&::-webkit-scrollbar': {
//                             display: 'none'
//                         },
//                         scrollbarWidth: 'none',
//                         '-ms-overflow-style': 'none',
//                         zIndex: 1001,
//                         left:"10px",
//                     },
//                 }}
//                 ModalProps={{ keepMounted: true }}
//             >
//                 <Box sx={{
//                     flexShrink: 0, // Prevents this from shrinking
//                     background: '#fff',
//                     zIndex: 10,
//                     position: 'sticky',
//                     top: 0,
//                 }}>
//                     <List sx={{ paddingTop: "8px", marginBottom: "0px",paddingBottom:"0px" }}>
//                         {menuItems.length === 0 ? (
//                             <Box sx={{ color: "gray", padding: "1rem", textAlign: "center", fontSize: getTextSize() }}>
//                                 No menu items found
//                             </Box>
//                         ) : (
//                             menuItems.map((item, index) => {
//                                 const dropdownContent = getDropdownContent(item);
//                                 const isSelected = selectedItem?.text === item.text;

//                                 return (
//                                     <React.Fragment key={index} >
//                                         <ListItem disablePadding sx={{ marginTop: "0px",marginBottom:"0px" }}>
//                                             <ListItemButton
//                                                 sx={{
//                                                     background: isSelected && dropdownOpen ? "#A055B0" : "#B276C3",
//                                                     borderRadius: "20px",
//                                                     marginBottom: "10px",
//                                                     color: "#fff",
//                                                     "&:hover": { background: "#A055B0" },
//                                                     padding: "10px 16px",
//                                                     position: "relative",
//                                                 }}
//                                                 onClick={() => handleMenuItemClick(item)}
//                                             >
//                                                 {/* Close Panel Button */}
//                                                 {open && (
//                                                     <IconButton
//                                                         size="small"
//                                                         onClick={(e) => {
//                                                             e.stopPropagation();
//                                                             setOpen(false);
//                                                         }}
//                                                         sx={{
//                                                             color: "#fff",
//                                                             position: "absolute",
//                                                             left: "5px",
//                                                             top: "45%",
//                                                             transform: "translateY(-50%)",
//                                                             backgroundColor: "rgba(255,255,255,0)",
//                                                             '&:hover': {
//                                                                 backgroundColor: "rgba(255,255,255,0)",
//                                                             },
//                                                             marginRight: "5px",
//                                                             display: window.innerWidth <= 990 ? "block" : "none",
//                                                         }}
//                                                     >
//                                                         <ArrowBackIosIcon fontSize="small" />
//                                                     </IconButton>
//                                                 )}

//                                                 <ListItemText
//                                                     primary={item.text}
//                                                     primaryTypographyProps={{
//                                                         style: {
//                                                             fontSize: getTextSize(),
//                                                             fontWeight: "bold",
//                                                             marginLeft: window.innerWidth <= 990 ? "10px" : "0px",


//                                                         },
//                                                     }}
//                                                 />

//                                                 {dropdownContent.length > 0 && (
//                                                     isSelected && dropdownOpen ? <ExpandLess /> : <ExpandMore />
//                                                 )}
//                                             </ListItemButton>
//                                         </ListItem>
//                                     </React.Fragment>
//                                 );
//                             })
//                         )}
//                     </List>
//                 </Box>

//                 {/* Scrollable Area for Sub-buttons */}
//                 <Box sx={{
//                     flex: 1, // Takes remaining space
//                     overflowY: 'auto',
//                     paddingBottom: '20px',
//                     '&::-webkit-scrollbar': {
//                         display: 'none'
//                     },
//                     scrollbarWidth: 'none',
//                     '-ms-overflow-style': 'none'
//                 }}>
//                     {menuItems.map((item, index) => {
//                         const dropdownContent = getDropdownContent(item);
//                         const isSelected = selectedItem?.text === item.text;

//                         return (
//                             dropdownContent.length > 0 && isSelected && dropdownOpen && (
//                                 <Box key={`dropdown-${index}`} sx={{ marginBottom: "10px" }}>
//                                     <Collapse in={isSelected && dropdownOpen} timeout="auto" unmountOnExit>
//                                         <List component="div" disablePadding sx={{marginBottom:"50px"}}>
//                                             {dropdownContent.map((dropdownItem, idx) => (
//                                                 <ListItemButton
//                                                     key={idx}
//                                                     sx={{
//                                                         pl: 4,
//                                                         background: location.pathname === dropdownItem.route ? "#A055B0" : "#B276C3",
//                                                         borderRadius: "20px",
//                                                         marginBottom: "10px",
//                                                         color: "#fff",
//                                                         "&:hover": { background: "#A055B0" },
//                                                         padding: "10px 16px",
//                                                         marginLeft: "8px",
//                                                         marginRight: "8px",
//                                                     }}
//                                                     onClick={() => handleDropdownItemClick(dropdownItem.route)}
//                                                 >
//                                                     <Box sx={{
//                                                         color: "#fff",
//                                                         minWidth: "27px",
//                                                         display: "flex",
//                                                         alignItems: "center",
//                                                         justifyContent: "center"
//                                                     }}>
//                                                         {renderIcon(dropdownItem.icon, "small")}
//                                                     </Box>
//                                                     <ListItemText
//                                                         primary={dropdownItem.text}
//                                                         primaryTypographyProps={{
//                                                             style: {
//                                                                 fontSize: getTextSize() === "11px" ? "10px" :
//                                                                     getTextSize() === "12px" ? "11px" : "12px",
//                                                                 fontWeight: "bold",
//                                                             },
//                                                         }}
//                                                     />
//                                                 </ListItemButton>
//                                             ))}
//                                         </List>
//                                     </Collapse>
//                                 </Box>
//                             )
//                         );
//                     })}
//                 </Box>
//             </Drawer>
//         </>
//     );
// };

// export default LandingSideBar2;







import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react"; // ← Add forwardRef and useImperativeHandle here
import {
    Box,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Drawer,
    useMediaQuery,
    useTheme,
    Collapse,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import {
    Home as HomeIcon,
    RestaurantMenu as RestaurantMenuIcon,
    Apartment as ApartmentIcon,
    Settings as SettingsIcon,
    Dashboard as DashboardIcon,
    DinnerDining as DinnerDiningIcon,
    Payment as PaymentIcon,
    Assessment as AssessmentIcon,
    Dashboard
} from "@mui/icons-material";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {
    FaUtensils,
    FaConciergeBell,
    FaShoppingBasket,
    FaBuilding
} from "react-icons/fa";
import { useSidebar } from "../../context/SidebarContext";

import {
    Building, Settings, Utensils, ShoppingBag,
    ChefHat, Truck, User, Tag,
    Table, Package, BarChart, Home, Users, Star, Headphones, Bell, FileText
} from 'lucide-react';
import { text } from "framer-motion/client";

// All possible menu items - these will only open dropdowns, not navigate
const allMenuItems = [
    // { text: "Subscription", icon: <HomeIcon />, vertical: "SUBSCRIPTION" },
    { text: "Food & Beverages", route: "/foodladingpage", vertical: "FOOD_AND_BEVERAGES" },
    // { text: "Catering & Services", icon: <RestaurantMenuIcon />, vertical: "CATERINGS_SERVICES" },
    // { text: "Logistics & Supply", icon: <LocalShippingIcon />, vertical: "LOGISTICS_SUPPLY" },
    // { text: "Fresh & Grocery", icon: <ShoppingBasketIcon />, vertical: "FRESH_GROCERIES" }
];




const subscriptionEnumToMenuItemMap = {
    Food_Beverages: {
        text: "Food & Beverages",
        icon: FaUtensils,
        route: "/mainladdingpage?vertical=food"
    },
    Catering_Services: {
        text: "Catering & Services",
        icon: FaConciergeBell,
        route: "/mainladdingpage?vertical=catering"
    },
    Fresh_Grocery: {
        text: "Fresh & Grocery",
        icon: FaShoppingBasket,
        route: "/mainladdingpage?vertical=grocery"
    },
    Logistics_Supply: {
        text: "Logistics & Supply",
        icon: LocalShippingIcon,
        route: "/mainladdingpage?vertical=logistics"
    },
    Banquet_Hall: {
        text: "Banquet Hall",
        icon: FaBuilding,
        route: "/mainladdingpage?vertical=banquet"
    },
};

// Your actual dropdown content mapping with safe icon handling
const enumToMenuItemMap = {
    Dashboard: {
        text: "Dashboard", icon: HomeIcon,
        route: "/fooddashboard"
    },
    // Home: { text: "Home", icon: HomeIcon, route: "/foodladingpage" },
    Company: { text: "Business Profile", icon: Building, route: "/foodbeveragescompany" },
    Settings_Controls: {
        text: "Settings & Control",
        icon: Settings,
        route: "/foodsettings"
    },
    Menu_Management: {
        text: "Menu",
        icon: Utensils,
        route: "/foodandbeveragesMenu"
    },
    // Inventory_Management: {
    //     text: "Inventory",
    //     icon: Package,
    //     route: "/foodandbeveragesInvetory"
    // },
    Order_Management: {
        text: "Order",
        icon: ShoppingBag,
        route: "/foodordermanagment"
    },
    Chef_Management: {
        text: "Chef",
        icon: ChefHat,
        route: "/foodchefmanagment"
    },
    // Table_Management: {
    //     text: "Table",
    //     icon: Table,
    //     route: "/foodtablemanagment"
    // },
    Delivery_Management: {
        text: "Delivery",
        icon: DinnerDiningIcon,
        route: "/foodwaitermanagment"
    },
    Team_Managment: { text: "Team", icon: Users, route: "/teammanagment" },
    Account_History: {
        text: "Account & History",
        icon: User,
        route: "/foodAccuontdata"
    },
    // Subscriptions: {
    //     text: "Subscription plans",
    //     route: "/subscriptionpackages"
    // },
    Promotions_Discounts: {
        text: "Promotions",
        icon: Tag,
        route: "/foodandbeveragespromotions"
    },
    // Ratings_Reviews: {
    //     text: "Ratings & Reviews",
    //     icon: Star,
    //     route: "/foodratings"
    // },
    // Support_System: {
    //     text: "Support System",
    //     icon: Headphones,
    //     route: "/foodandbeveragessupportsystem"
    // },
    Legal_Compliance: {
        text: "Leagl & Complaince",
        icon: FileText,
        route: "/foodsupportsystem"
    },
    // Notification: {
    //     text: "Notification",
    //     icon: Bell,
    //     route: "/notificationcontext"
    // },
    Report_Analysis: {
        text: "Report & Analysis",
        icon: BarChart,
        route: "/foodandreporanalysis"
    },
};

const cateringEnumToMenuItemMap = {
    Dashboard: { text: "Dashboard", route: "/cateringdashboard" },
    // Home: { text: "Home", icon: HomeIcon, route: "/cateringlading" },
    Company: { text: "Profile", icon: ApartmentIcon, route: "/cateringsprofilepage" },
    Settings_Controls: {
        text: "Settings & Control",
        icon: SettingsIcon,
        route: "/cateringssettingpage"
    },
    Menu_Management: {
        text: "Services & Products",
        icon: RestaurantMenuIcon,
        route: "/cateringsmenuaddingpage"
    },
    Order_Management: {
        text: "Leads Orders",
        icon: DashboardIcon,
        route: "/cateringsorderspage"
    },
    Table_Management: {
        text: "Package Orders",
        icon: DashboardIcon,
        route: "/cateringpackageorders"
    },
    Account_History: {
        text: "Account & History",
        icon: PaymentIcon,
        route: "/caterigsaccount"
    },

    Promotions_Discounts: {
        text: "Promotions",
        icon: PaymentIcon,
        route: "/cateringspromotionspage"
    },
    Report_Analysis: {
        text: "Report & Analysis",
        icon: AssessmentIcon,
        route: "/cateringsreportanalysis"
    },
}

const groceryEnumMenuToMap = {
    Home: { text: "Home", icon: HomeIcon, route: "/groceryladingpage" },
    Company: { text: "Profile", icon: ApartmentIcon, route: "/groceryprofiledata" },
    Settings_Controls: {
        text: "Settings & Control",
        icon: SettingsIcon,
        route: "/grocerysettingsdata"
    },
    Menu_Management: {
        text: "Menu",
        icon: RestaurantMenuIcon,
        route: "/groceryandbeveragesMenu"
    },
    Order_Management: {
        text: "Order",
        icon: DashboardIcon,
        route: "/groceryorders"
    },
    Account_History: {
        text: "Account & History",
        icon: PaymentIcon,
        route: "/groceryaccuontdata"
    },
    Promotions_Discounts: {
        text: "Promotions",
        icon: PaymentIcon,
        route: "/groceryandbeveragespromotions"
    },
    Inventory_Management: { text: "Inventory", icon: PaymentIcon, route: "/groceryandbeveragesInvetory" },
    Report_Analysis: {
        text: "Report & Analysis",
        icon: AssessmentIcon,
        route: "/groceryandreporanalysis"
    },
}

const LandingSideBar2 = () => {
    const [open, setOpen] = useState(false);
    const [menuItems, setMenuItems] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [allowedModules, setAllowedModules] = useState([]);
    const [allowedBusinessVerticals, setAllowedBusinessVerticals] = useState([]);
    const [filteredMenuItems, setFilteredMenuItems] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();


    // Get sidebar state from context
    const { sidebarOpen, toggleSidebar } = useSidebar();

    // Media queries
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));
    const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
    const isBelow500 = useMediaQuery("(max-width:500px)");
    const isBelow1315 = useMediaQuery("(max-width:1315px)");
    const isBetween1315And1399 = useMediaQuery("(min-width:1315px) and (max-width:1399px)");
    const isAbove1400 = useMediaQuery("(min-width:1450px)");

    const isBelow992 = useMediaQuery('(max-width:991px)'); // ← Add this

    // Your custom window width detection
    const isMobilee = window.innerWidth < 600;        // < 600px
    const isTablett = window.innerWidth >= 600 && window.innerWidth < 999; // 600px - 999px
    const isDesktopp = window.innerWidth >= 999;          // > 999px

    // const showHamburger = isMobilee || isTablett; // true for mobile AND tablet
    // Use 992px for showHamburger
    const showHamburger = window.innerWidth <= 991; // ← Changed to 991

    let drawerWidth = 189; // default

    if (isBelow500) {
        drawerWidth = 250;
    } else if (isBelow1315) {
        drawerWidth = 170;
    } else if (isBetween1315And1399) {
        drawerWidth = 180;
    } else if (isAbove1400) {
        drawerWidth = 215;
    }

    // Set sidebar to always be open above 992px
    useEffect(() => {
        if (!isBelow992) {
            // On desktop (above 992px), ensure sidebar is open
            // We need to set this in context
            const loginData = JSON.parse(localStorage.getItem("loginResponse") || "{}");
            // You might need to add a function to set sidebarOpen in your context
            // For now, we'll handle it in the Drawer component
        }
    }, [isBelow992]);
    const getIconSize = () => (isMobile ? "small" : "medium");
    const getTextSize = () => (isMobile ? "12px" : isTablet ? "0.8rem" : "0.9rem");

    // Set initial open state based on your custom window width detection
    useEffect(() => {
        if (showHamburger) {
            setOpen(false); // Closed by default on mobile/tablet
        } else {
            setOpen(true);  // Always open on desktop
        }
    }, [showHamburger]);

    // Permission-based module filtering - FROM REFERENCE FILE
    useEffect(() => {
        const employeeId = localStorage.getItem("employeeId");

        // Get login data
        const loginData = JSON.parse(localStorage.getItem("loginResponse") || "{}");
        const modulesFromResponse = loginData?.modules || [];
        const planTypes = loginData?.planTypes || [];
        const businessVerticalsFromResponse = loginData?.businessVerticals || [];

        let filteredModules = [];
        let filteredBusinessVerticals = [];

        if (employeeId && employeeId !== "0") {
            // Employee → show only modules from login response
            filteredModules = modulesFromResponse.map(m => m.trim().replace(/\s+/g, "_"));
            filteredBusinessVerticals = businessVerticalsFromResponse;
        } else {
            // Parent vendor → show modules depending on plan type
            if (planTypes.includes("BASIC")) {
                // BASIC has highest priority
                filteredModules = [
                    "Dashboard",
                    "Company",
                    "Team_Managment",
                    "Home",
                    "Settings_Controls",
                    "Order_Management",
                    "Menu_Management",
                    "Account_History",
                    "Report_Analysis",
                    "Promotions_Discounts",
                    "Notification",
                ];
                filteredBusinessVerticals = ["FOOD_AND_BEVERAGES", "CATERINGS_SERVICES"];
            } else if (planTypes.includes("PREMIUM")) {
                filteredModules = Object.keys(enumToMenuItemMap); // all modules
                filteredBusinessVerticals = businessVerticalsFromResponse;
            } else if (planTypes.includes("STANDARD")) {
                filteredModules = modulesFromResponse.length > 0
                    ? modulesFromResponse.map(m => m.trim().replace(/\s+/g, "_"))
                    : ["Home", "Order_Management"];
                filteredBusinessVerticals = businessVerticalsFromResponse;
            } else {
                filteredModules = ["Home", "Order_Management"];
                filteredBusinessVerticals = businessVerticalsFromResponse;
            }
        }

        // console.log("✅ Allowed modules:", filteredModules);
        // console.log("✅ Allowed businessVerticals:", filteredBusinessVerticals);

        setAllowedModules(filteredModules);
        setAllowedBusinessVerticals(filteredBusinessVerticals);

        // NEW: Apply permission filtering to menu items - FROM REFERENCE FILE
        const permissionFilteredItems = Object.keys(enumToMenuItemMap)
            .filter((key) => filteredModules.includes(key))
            .map((key) => enumToMenuItemMap[key]);

        setFilteredMenuItems(permissionFilteredItems);
        //console.log("✅ Permission filtered menu items:", permissionFilteredItems);

    }, []);

    // Filter menu items based on business verticals
    useEffect(() => {
        const loginData = JSON.parse(localStorage.getItem("loginResponse"));
        const businessVerticals = loginData?.businessVerticals || [];

        const filteredMenu = allMenuItems.filter(
            (item) =>
                item.text === "Subscription" || businessVerticals.includes(item.vertical)
        );

        setMenuItems(filteredMenu);
    }, []);

    const handleMenuItemClick = (item) => {
        // Toggle dropdown - only open/close dropdown, no navigation
        if (selectedItem?.text === item.text) {
            setDropdownOpen(!dropdownOpen);
        } else {
            setSelectedItem(item);
            setDropdownOpen(true);
        }
    };

    const handleDropdownItemClick = (route) => {
        // This will handle navigation for dropdown items
        navigate(route);
        if (isMobile) setOpen(false);
        // setDropdownOpen(false); // Close dropdown after navigation
    };

    // Safe icon renderer function
    const renderIcon = (IconComponent, size) => {
        if (!IconComponent || typeof IconComponent === 'undefined') {
            return <DashboardIcon fontSize={size} />; // Fallback icon
        }
        return <IconComponent fontSize={size} />;
    };

    // Filter dropdown content based on allowed modules - UPDATED with permission filtering
    const getDropdownContent = (item) => {
        let dropdownItems = [];

        switch (item.text) {
            case "Food & Beverages":
                // NEW: Use permission-filtered items instead of all items
                dropdownItems = filteredMenuItems.length > 0 ? filteredMenuItems : Object.values(enumToMenuItemMap);
                break;
            case "Subscription":
                dropdownItems = Object.values(subscriptionEnumToMenuItemMap);
                break;
            case "Catering & Services":
                dropdownItems = Object.values(cateringEnumToMenuItemMap);
                break;
            case "Logistics & Supply":
                dropdownItems = [
                    { text: "Shipping", icon: LocalShippingIcon, route: "/shipping" },
                    { text: "Warehouse", icon: LocalShippingIcon, route: "/warehouse" },
                ];
                break;
            case "Fresh & Grocery":
                dropdownItems = Object.values(groceryEnumMenuToMap);
                break;
            default:
                dropdownItems = [];
        }

        // Additional filtering based on allowed modules for cross-vertical consistency
        return dropdownItems.filter(dropdownItem => {
            // Find the module key that matches this dropdown item
            const moduleKey = Object.keys(enumToMenuItemMap).find(key =>
                enumToMenuItemMap[key].text === dropdownItem.text
            );

            // If we found a module key, check if it's allowed
            // If no module key found (different vertical), allow it
            return !moduleKey || allowedModules.includes(moduleKey);
        });
    };
    // Set initial open state based on your custom window width detection
    useEffect(() => {
        if (showHamburger) {
            setOpen(false); // Closed by default on mobile/tablet
        } else {
            setOpen(true);  // Always open on desktop
        }
    }, [showHamburger]);


    return (
        <>
            {/* Open Panel Button - Only show when sidebar is closed AND we're below 992px */}
            {/* {!sidebarOpen && isBelow992 && (
                <Box
                    sx={{
                        position: "fixed",
                        top: isMobile ? "12%" : "150px",
                        left: isMobile ? "10px" : "10px",
                        zIndex: 1500,
                    }}
                >
                    <IconButton
                        onClick={toggleSidebar}
                        sx={{
                            color: "#b15cd6",
                            backgroundColor: "white",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                            '&:hover': {
                                backgroundColor: "#f5f55",
                            },
                            height: "25px",
                            width: "25px",
                        }}
                    >
                        <ArrowForwardIosIcon />
                    </IconButton>
                </Box>
            )} */}

            <Drawer
                anchor="left"
                variant={isBelow992 ? "temporary" : "persistent"} // Temporary below 992px, persistent above
                open={isBelow992 ? sidebarOpen : true} // Always open above 992px
                onClose={isBelow992 ? toggleSidebar : undefined} // Only closeable below 992px
                PaperProps={{
                    sx: {
                        marginTop: isMobile ? "52px" : "118px",
                        height: isMobile ? "calc(100vh - 50px)" : "calc(100vh - 50px)",
                        width: drawerWidth,
                        scrollbarWidth: "none",
                        backgroundColor: "#fff",
                        border: "3px solid white",
                        overflow: 'hidden',
                        '&::-webkit-scrollbar': {
                            display: 'none'
                        },
                        scrollbarWidth: 'none',
                        '-ms-overflow-style': 'none',
                        zIndex: 1001,
                        left: "00px",
                    },
                }}
                ModalProps={{ keepMounted: true }}
            >
                {/* Single scrollable container for everything */}
                <Box sx={{
                    height: '100%',
                    overflowY: 'auto',
                    '&::-webkit-scrollbar': { display: 'none' },
                    scrollbarWidth: 'none',
                    '-ms-overflow-style': 'none',
                    paddingBottom: '20px'
                }}>
                    <List sx={{ paddingTop: "8px", paddingBottom: "60px" }}>
                        {menuItems.map((item, index) => {
                            const isSelected = selectedItem?.text === item.text;
                            const dropdownContent = getDropdownContent(item);

                            return (
                                <React.Fragment key={index}>
                                    {/* MAIN BUTTON */}
                                    <ListItem disablePadding sx={{ marginTop: "0px", marginBottom: "0px" }}>
                                        <ListItemButton
                                            sx={{
                                                background: isSelected ? "#A055B0" : "#B276C3",
                                                borderRadius: "20px",
                                                marginBottom: "10px",
                                                color: "#fff",
                                                "&:hover": { background: "#A055B0" },
                                                padding: "10px 16px",
                                                position: "relative",
                                                marginLeft: "8px",
                                                marginRight: "8px",
                                            }}
                                            onClick={() => handleMenuItemClick(item)}
                                        >
                                            {/* Close button - Only show on mobile/tablet */}
                                            {/* {sidebarOpen && isBelow992 && (
                                                <IconButton
                                                    size="small"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleSidebar();
                                                    }}
                                                    sx={{
                                                        color: "#fff",
                                                        position: "absolute",
                                                        left: "5px",
                                                        top: "45%",
                                                        transform: "translateY(-50%)",
                                                        backgroundColor: "rgba(255,255,255,0)",
                                                        '&:hover': { backgroundColor: "rgba(255,255,255,0)" },
                                                        marginRight: "5px",
                                                        display: window.innerWidth <= 990 ? "block" : "none",
                                                    }}
                                                >
                                                    <ArrowBackIosIcon fontSize="small" />
                                                </IconButton>
                                            )} */}

                                            <ListItemText
                                                primary={item.text}
                                                primaryTypographyProps={{
                                                    style: {
                                                        fontSize: getTextSize(),
                                                        fontWeight: "bold",
                                                        marginLeft: window.innerWidth <= 990 ? "10px" : "0px",
                                                    },
                                                }}
                                            />

                                            {dropdownContent.length > 0 && (
                                                isSelected && dropdownOpen ? <ExpandLess /> : <ExpandMore />
                                            )}
                                        </ListItemButton>
                                    </ListItem>

                                    {/* DROPDOWN LINKS for THIS BUTTON ONLY */}
                                    {isSelected && dropdownOpen && dropdownContent.length > 0 && (
                                        <Box sx={{ paddingLeft: "16px", paddingRight: "16px", marginBottom: "10px" }}>
                                            {dropdownContent.map((dropdownItem, idx) => (
                                                <ListItemButton
                                                    key={idx}
                                                    sx={{
                                                        pl: 4,
                                                        background: location.pathname === dropdownItem.route ? "#A055B0" : "#B276C3",
                                                        borderRadius: "20px",
                                                        marginBottom: "8px",
                                                        color: "#fff",
                                                        "&:hover": { background: "#A055B0" },
                                                        padding: "8px 16px",
                                                    }}
                                                    onClick={() => handleDropdownItemClick(dropdownItem.route)}
                                                >
                                                    <Box sx={{
                                                        color: "#fff",
                                                        minWidth: "27px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}>
                                                        {renderIcon(dropdownItem.icon, "small")}
                                                    </Box>
                                                    <ListItemText
                                                        primary={dropdownItem.text}
                                                        primaryTypographyProps={{
                                                            style: {
                                                                fontSize: getTextSize() === "11px" ? "10px" :
                                                                    getTextSize() === "12px" ? "11px" : "12px",
                                                                fontWeight: "bold",
                                                            },
                                                        }}
                                                    />
                                                </ListItemButton>
                                            ))}
                                        </Box>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </List>
                </Box>
            </Drawer>
        </>
    );
};

export default LandingSideBar2;